<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axiosInstance from '@/plugins/axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


const router = useRouter();
const route = useRoute();
const loading = ref(false);
const theme = ref<any>({});
const themeId = computed(() => {
    return route.params.id;
});
const availableFonts = ref<any>([])

const getTheme = async () => {
    loading.value = true;
    try {
        const response = await axiosInstance.get(`/theme/byId/${themeId.value}`);
        theme.value = response.data;
    } catch (error) {
        console.error(error);
    } finally {
        loading.value = false;
    }
};

const saveTheme = async () => {
    loading.value = true;
    try {
        await axiosInstance.put(`/theme/byId/${themeId.value}`, theme.value);
        router.push({ path: '/admin/settings/themes' });
    } catch (error) {
        console.error(error);
    } finally {
        loading.value = false;
    }
};

const getAvailableFonts = async () => {
    loading.value = true;
    try {
        const response = await axiosInstance.get('/admin/availableFonts');
        availableFonts.value = response.data;
    } catch (error) {
        console.error(error);
    } finally {
        loading.value = false;
    }
};


onMounted(async () => {
    await getTheme();
    await getAvailableFonts();
});

</script>



<template>
    <div>
        <div class="row mb-5 col-12 justify-content-between">
            <div class="col">
                <Button class="d-flex float-end p-button-tuev ml-2" label="Save" @click="saveTheme" iconPos="left">
                    <template #icon>
                        <font-awesome-icon :icon="['fas', 'save']" />
                    </template>
                </Button>

            </div>
        </div>

        <div class="row justify-content-center card p-3">
            <div class="row mb-3">
                <label for="themeName" class="col-sm-2 col-form-label">Theme Name</label>
                <div class="col-sm-10">
                    <InputText id="themeName" v-model="theme.name" class="form-control" />
                </div>
            </div>
            <div class="row mb-3">
                <label for="availableFonts" class="col-sm-2 col-form-label">Available Fonts</label>
                <div class="col-sm-10">
                    <MultiSelect 
                        id="availableFonts" 
                        v-model="theme.availableFonts" 
                        :options="availableFonts" 
                        class="form-control" 
                        placeholder="Select Fonts" 
                    />
                </div>
            </div>
        </div>
    </div>
</template>